module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-About2.dca6149a.webp";